import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/index";
import Intro from "../pages/Intro";
import Page404 from "../pages/Page404";
import ReactNativeExpo from "../pages/ReactNativeExpo";
import RailsRedisSidekiq from "../pages/RailsRedisSidekiq";
import ResendRailsSidekiq from "../pages/ResendRailsSidekiq";
import FCMPushNotifications from "../pages/FCMPushNotifications";
import TokenAndRails from "../pages/TokenAndRails";
import UbuntuTweaks from "../pages/UbuntuTweaks";
import Favorites from "../pages/Favorites";
import TiiRADA from "../pages/TiiRADA";
import LocalInfra from "../pages/LocalInfra";
import VoiceToText from "../pages/VoiceToText";
import Rails8PushNotifications from "../pages/Rails8PushNotifications";
import DevToolingWorkflow from "../pages/DevToolingWorkflow";
import GeofencingTiirada from "../pages/GeofencingTiirada";
import Admin from "../pages/Admin";

import { LightboxProvider } from "../context/LightboxContext";

import ScrollToTop from "./ScrollToTop";
import PageTransition from "./PageTransition";
import ReadingProgress from "./ReadingProgress";
import CodeCopyHandler from "./CodeCopyHandler";
import SectionAnchorHandler from "./SectionAnchorHandler";
import PostNavigation from "./PostNavigation";

function Main() {
  return (
    <LightboxProvider>
        <div id="main">
          <ReadingProgress />
          <ScrollToTop />
          <CodeCopyHandler />
          <SectionAnchorHandler />
          <PageTransition>
          <Routes>
            <Route path="/" element={< Home />} />
            <Route path="/about/" element={< Intro />} />
            <Route path="/blog/" element={< Navigate to="/" replace />} />
            <Route path="/blog/react-native-expo-essentials/" element={< ReactNativeExpo />} />
            <Route path="/blog/rails-redis-sidekiq-notifications/" element={< RailsRedisSidekiq />} />
            <Route path="/blog/resend-rails-sidekiq-emails/" element={< ResendRailsSidekiq />} />
            <Route path="/blog/fcm-push-notifications-rails-react-native/" element={< FCMPushNotifications />} />
            <Route path="/blog/the-token-and-the-rails/" element={< TokenAndRails />} />
            <Route path="/blog/ubuntu-linux-tweaks-wiki/" element={< UbuntuTweaks />} />
            <Route path="/blog/tiirada-mobile/" element={< TiiRADA />} />
            <Route path="/blog/local-infra-ubuntu-26-04/" element={< LocalInfra />} />
            <Route path="/blog/gnome-voice-to-text-whisper/" element={< VoiceToText />} />
            <Route path="/blog/rails-8-react-native-push-notifications/" element={< Rails8PushNotifications />} />
            <Route path="/blog/terminal-first-dev-workflow/" element={< DevToolingWorkflow />} />
            <Route path="/blog/geofencing-without-postgis-tiirada/" element={< GeofencingTiirada />} />
            <Route path="/favorites/" element={< Favorites />} />
            <Route path="/analytics/" element={< Admin />} />
            <Route path="*" element={< Page404 />} />
          </Routes>
          <PostNavigation />
          </PageTransition>
        </div>
    </LightboxProvider>
  );
}

export default Main;
